import { Component } from '@angular/core';
import {Router, NavigationEnd} from "@angular/router";
import { Auth0Service } from './common/services/auth0/auth0.service';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.css']
})
export class AppComponent {



  constructor(private router: Router, private auth0: Auth0Service) {

        // handle Social Login popup
        this.auth0.init();
        this.router.events.subscribe(event => {
          this.auth0.checkPopup();
          if (event instanceof NavigationEnd) {
                (<any>window).gtag('config', 'UA-122858067-1', {'page_title' : event.urlAfterRedirects ,'page_path': event.urlAfterRedirects});

              }
        });

  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts